module.exports = require('./src/google-maps-api-loader.js');



//////////////////
// WEBPACK FOOTER
// /Users/mateusz/Projects/wielkiepytania/wp-content/themes/wielkiepytania/node_modules/google-maps-api-loader/index.js
// module id = 18
// module chunks = 0